import Vue from 'vue'
import VueRouter from 'vue-router'
import AssignEthicCourse from '../pages/AssignEthicCourse'
import Dashboard from '../pages/Dashboard'
import EditProtocol from '../pages/EditProtocol'
import GeneralReport from '../pages/GeneralReport'
import GeneralListOfProtocolsReport from '../pages/GeneralListOfProtocolsReport'
import RegisterEthicsQuestionnaire from '../pages/RegisterEthicsQuestionnaire'
import RegisterProtocol from '../pages/RegisterProtocol'
import RegisterResearchLine from '../pages/RegisterResearchLine'
import RegisterFinancing from '../pages/RegisterFinancing'
import RegisterSecondaryProtocol from '../pages/RegisterSecondaryProtocol'
import RegisterAdverseEvents from '../pages/RegisterAdverseEvents'
import RegisterAcademicTraining from '../pages/RegisterAcademicTraining'
import RegisterAffiliation from '../pages/RegisterAffiliation'
import RegisterArticle from '../pages/RegisterArticle'
import RegisterBibliographicCitation
  from '../pages/RegisterBibliographicCitation'
import RegisterInterestArea from '../pages/RegisterInterestArea'
import RegisterGrantAndFellowship from '../pages/RegisterGrantAndFellowship'
import RegisterEditorialCouncil from '../pages/RegisterEditorialCouncil'
import RegisterProfessionalExperience
  from '../pages/RegisterProfessionalExperience'
import RegisterAwardAndHonour from '../pages/RegisterAwardAndHonour'
import RegisterThesisDirection from '../pages/RegisterThesisDirection'
import RegisterLanguage from '../pages/RegisterLanguage'
import RegisterPatent from '../pages/RegisterPatent'
import RegisterNameBibliographicCitation
  from '../pages/RegisterNameBibliographicCitation'
import RegisterCourseAndWorkshop from '../pages/RegisterCourseAndWorkshop'
import RegisterBookChapter from '../pages/RegisterBookChapter'
import RegisterMagazine from '../pages/RegisterMagazine'
import ImportMagazines from '../pages/ImportMagazines'
import RegisterWorkplace from '../pages/RegisterWorkplace'
import RegisterFunder from '../pages/RegisterFunder'
import RegisterEthicCourse from '../pages/RegisterEthicCourse'
import RegisterProtocolAdvancePeriod
  from '../pages/RegisterProtocolAdvancePeriod'
import RegisterRole from '../pages/RegisterRole'
import RegisterScience from '../pages/RegisterScience'
import RegisterDiscipline from '../pages/RegisterDiscipline'
import RegisterSubdiscipline from '../pages/RegisterSubdiscipline'
import RegisterRpbiCourse from '../pages/RegisterRpbiCourse'
import RegisterUser from '../pages/RegisterUser'
import EditUserPassword from '../pages/EditUserPassword'
import MigrateUser from '../pages/MigrateUser'
import Search from '../pages/Search'
import ShowProtocol from '../pages/ShowProtocol'
import UserSiiLevel from '../pages/UserSiiLevel'
import UserSniLevel from '../pages/UserSniLevel'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/protocolo/registrar',
      name: 'protocol.register',
      component: RegisterProtocol,
    }, {
      path: '/protocolo/registrar/secundario/:protocol',
      name: 'protocol.register.secondary',
      component: RegisterProtocol,
    }, {
      path: '/protocolo/:protocol/editar',
      name: 'protocol.edit',
      component: EditProtocol,
    }, {
      path: '/protocolo/:protocol/datos/consulta',
      name: 'protocol.data.view',
      component: EditProtocol,
    },
    {
      path: '/protocolo/:protocol/ver',
      name: 'protocol.show',
      component: ShowProtocol,
    },
    {
      path: '/protocolo/cuestionario/etica/registrar',
      name: 'ethics.questionnaire.register',
      component: RegisterEthicsQuestionnaire,
    },
    {
      path: '/protocolo/:protocol/evaluacion/lider',
      name: 'protocol.leader.evaluation',
      component: Dashboard,
    },
    {
      path: '/protocolo/:protocol/evaluacion/director',
      name: 'protocol.director.evaluation',
      component: Dashboard,
    }, {
      path: '/protocolo/:protocol/evaluacion/protocolo',
      name: 'protocol.evaluation',
      component: Dashboard,
    }, {
      path: '/protocolo/:protocol/evaluacion/comite',
      name: 'protocol.committee.evaluation',
      component: Dashboard,
    }, {
      path: '/committee/:committee/reviewer/:reviewer/reply',
      name: 'protocol.committee.reviewer.reply',
      component: Dashboard,
    },
    {
      path: '/protocolo/:protocol/financiamiento/registrar',
      name: 'financing.register',
      component: RegisterFinancing,
    },
    {
      path: '/protocolo/secundario/registrar',
      name: 'secondary_protocol.register',
      component: RegisterSecondaryProtocol,
    },
    {
      path: '/protocolo/:protocol/evento/adverso/registrar',
      name: 'adverse_event.register',
      component: RegisterAdverseEvents,
    }, {
      path: '/curriculo/formacion-academica/:id?/(registrar|editar)',
      name: 'curriculum.academic.training.register',
      component: RegisterAcademicTraining,
    },
    {
      path: '/curriculo/afiliaciones/:id?/(registrar|editar)',
      name: 'curriculum.afilliations.register',
      component: RegisterAffiliation,
    },
    {
      path: '/curriculo/articulo/:id?/(registrar|editar)',
      name: 'name.article.register',
      component: RegisterArticle,
    },
    {
      path: '/curriculo/citas-bibliograficas/:id?/(registrar|editar)',
      name: 'curriculum.bibliographic.citations.register',
      component: RegisterBibliographicCitation,
    },
    {
      path: '/curriculo/areas-de-interes/:id?/(registrar|editar)',
      name: 'curriculum.interest.areas.register',
      component: RegisterInterestArea,
    },
    {
      path: '/curriculo/grants-and-fellowships/:id?/(registrar|editar)',
      name: 'curriculum.grants.and.fellowships.register',
      component: RegisterGrantAndFellowship,
    },
    {
      path: '/curriculo/consejos-editoriales/:id?/(registrar|editar)',
      name: 'curriculum.editorial.councils.register',
      component: RegisterEditorialCouncil,
    },
    {
      path: '/curriculo/experiencia-profesional/:id?/(registrar|editar)',
      name: 'curriculum.professional.experience.register',
      component: RegisterProfessionalExperience,
    },
    {
      path: '/curriculo/premios-y-reconocimientos/:id?/(registrar|editar)',
      name: 'curriculum.awards.and.honours.register',
      component: RegisterAwardAndHonour,
    },
    {
      path: '/curriculo/direccion-de-tesis/:id?/(registrar|editar)',
      name: 'curriculum.thesis.directions.register',
      component: RegisterThesisDirection,
    },
    {
      path: '/curriculo/idiomas/:id?/(registrar|editar)',
      name: 'curriculum.language.register',
      component: RegisterLanguage,
    },
    {
      path: '/curriculo/patentes/:id?/(registrar|editar)',
      name: 'curriculum.patents.register',
      component: RegisterPatent,
    },
    {
      path: '/curriculo/nombre-citas-bibliograficas/:id?/(registrar|editar)',
      name: 'name.bibliographic.citations.register',
      component: RegisterNameBibliographicCitation,
    },
    {
      path: '/curriculo/cursos-y-talleres/:id?/(registrar|editar)',
      name: 'name.courses.and.workshops.register',
      component: RegisterCourseAndWorkshop,
    },
    {
      path: '/curriculo/libro-capitulo/:id?/(registrar|editar)',
      name: 'name.books.chapters.register',
      component: RegisterBookChapter,
    },
    {
      path: '/catalogo/lineas/:id?/(registrar|editar)',
      name: 'research.line.register',
      component: RegisterResearchLine,
    },
    {
      path: '/catalogo/revistas/:id?/(registrar|editar)',
      name: 'magazines.register',
      component: RegisterMagazine,
    },
    {
      path: '/catalogo/revistas/importar',
      name: 'magazines.import',
      component: ImportMagazines,
    },
    {
      path: '/catalogo/centros/:id?/(registrar|editar)',
      name: 'workplaces.register',
      component: RegisterWorkplace,
    },
    {
      path: '/catalogo/financiadoras/:id?/(registrar|editar)',
      name: 'funders.register',
      component: RegisterFunder,
    },
    {
      path: '/catalogo/cursos/etica/:id?/(registrar|editar)',
      name: 'ethics.course.register',
      component: RegisterEthicCourse,
    },
    {
      path: '/catalogo/cursos/etica/asignar',
      name: 'ethics.course.assign',
      component: AssignEthicCourse,
    },
    {
      path: '/catalogo/cursos/etica/asignado/:id/editar',
      name: 'ethics.course.assign.edit',
      component: AssignEthicCourse,
    },
    {
      path: '/catalogo/periodos-de-avance-de-protocolos/:id?/(registrar|editar)',
      name: 'protocol.advance.periods.register',
      component: RegisterProtocolAdvancePeriod,
    },
    {
      path: '/catalogo/roles/:id?/(registrar|editar)',
      name: 'protocol.roles.register',
      component: RegisterRole,
    },
    {
      path: '/catalogo/ciencias/:id?/(registrar|editar)',
      name: 'sciences.register',
      component: RegisterScience,
    },
    {
      path: '/catalogo/disciplinas/:id?/(registrar|editar)',
      name: 'disciplines.register',
      component: RegisterDiscipline,
    },{
      path: '/catalogo/subdisciplinas/:id?/(registrar|editar)',
      name: 'subdisciplines.register',
      component: RegisterSubdiscipline,
    },
    {
      path: '/catalogo/cursos/rpbi/:id?/(registrar|editar)',
      name: 'rpbi.course.register',
      component: RegisterRpbiCourse,
    },
    {
      path: '/catalogo/usuarios/:id?/(registrar|editar)',
      name: 'users.register',
      component: RegisterUser,
      props: route => ({
        user: route.params.id,
      })
    },
    {
      path: '/catalogo/usuarios/:id/migrar',
      name: 'users.migrate',
      component: MigrateUser,
      props: route => ({
        user: route.params.id,
      })
    },
    {
      path: '/usuario/:id/cambiar-accesos',
      name: 'users.edit.password',
      component: EditUserPassword,
      props: route => ({
        user: route.params.id,
      })
    },
    {
      path: '/enmienda/:amendment/:type/consultar',
      name: 'amendment.view',
      component: Dashboard,
    },
    {
      path: '/reporte/informe-general',
      name: 'general.report',
      component: GeneralReport,
    },
    {
      path: '/reporte/listado-general-de-protocolos',
      name: 'general.list.protocols.report',
      component: GeneralListOfProtocolsReport,
    },
    {
      path: '/dashboard/:section?/:id?',
      name: 'dashboard',
      component: Dashboard,
      props:  route => ({
        readonly: route.query.ref === 'historico_protocolo'
      }),
    },
    {
      path: '/buscar',
      name: 'search',
      component: Search,
    },
    {
      path: '/usuario/:id/nivel-sii/(registrar|editar)',
      name: 'users.sii_level',
      component: UserSiiLevel,
    },
    {
      path: '/usuario/:id/nivel-sni/(registrar|editar)',
      name: 'users.sni_level',
      component: UserSniLevel,
    },
  ],
})

router.beforeEach((to, from, next) => {
  console.log(from, to)
  next()
})

export default router
